import React, { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToBooking = () => {
    const element = document.getElementById('booking-section');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ease-in-out ${
      scrolled 
        ? 'bg-vintage-white/95 backdrop-blur-md py-3 md:py-4 shadow-[0_2px_15px_rgba(47,43,40,0.05)]' 
        : 'bg-transparent py-5 md:py-8'
    }`}>
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 flex justify-between items-center">
        <a 
          href="#" 
          className={`font-serif text-xl md:text-2xl lg:text-3xl tracking-wide transition-colors duration-500 ${
            scrolled ? 'text-deep-charcoal' : 'text-vintage-white drop-shadow-sm'
          }`}
        >
          Padua Weddings
        </a>
        
        <button 
          onClick={scrollToBooking} 
          className={`uppercase tracking-[0.2em] text-[10px] md:text-xs font-bold px-5 py-3 md:px-8 md:py-3.5 transition-all duration-500 active:scale-95 ${
            scrolled 
              ? 'bg-deep-charcoal text-vintage-white hover:bg-estate-bronze' 
              : 'bg-vintage-white text-deep-charcoal hover:bg-aged-ivory shadow-lg'
          }`}
        >
          Book Tour
        </button>
      </div>
    </nav>
  );
}